<template>
	<div><span class="biaoti">供应商</span>
		<el-tabs type="border-card"  v-model="tabs" @tab-remove="Tabremove">
			<el-tab-pane label="供应商" name="lie">
				<el-collapse>
					<el-collapse-item title="搜索">
						<el-form ref="form" :model="so" label-width="80px" style="margin-left: 80px;">
							<el-form-item label="关键词">
								<el-input v-model="so.guanjianci" placeholder="名称/手机/昵称/账号"></el-input>
							</el-form-item>
							<el-form-item label="状态">
								<el-select v-model="so.zhuangtai" placeholder="状态" style="width: 100%;">
									<el-option label="不限" value=""></el-option>
									<el-option label="已审核" value="1"></el-option>
									<el-option label="审核中" value="5"></el-option>
									<el-option label="未审核" value="0"></el-option>
								</el-select>
							</el-form-item>
							<el-button size="medium" type="info" style="margin-left: 80px;" @click="CSH">搜索</el-button>
						</el-form>
					</el-collapse-item>
				</el-collapse>
				<el-table :data="shu">
					<el-table-column prop="id" label="ID" width="80"></el-table-column>
					<el-table-column prop="ming" label="店铺名称" width="250"></el-table-column>
					<el-table-column label="绑定会员" width="250">
						<template slot-scope="shu">
							<el-avatar shape="square" :src="shu.row.touxiang" v-if="shu.row.touxiang"></el-avatar>
							<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.nicheng}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="dianhua" label="手机" width="150"></el-table-column>
					<el-table-column prop="shijian" label="注册时间" width="200"> </el-table-column>
					<el-table-column prop="peisongfangshi" label="配送方式" width="180">
						<template slot-scope="shu">
							<el-radio-group v-model="shu.row.peisongfangshi"  @change="Peisongfangshi(shu.row)"  size="mini">
							      <el-radio-button label="0">派送上门</el-radio-button>
							      <el-radio-button label="1">到店自提</el-radio-button>							     
							</el-radio-group>							
						</template>
					</el-table-column>
					<el-table-column prop="zhuangtai" label="审核" width="120">
						<template slot-scope="shu">
							<el-switch v-model="shu.row.zhuangtai" active-value="1" inactive-value="0" @change="Shenhe(shu.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="caozuo" label="操作">
						<template slot-scope="shu">							
							<el-button icon="el-icon-printer" size="mini" @click="Mianbandakai(['dayin',shu.row])"></el-button>
							<el-button icon="el-icon-user" size="mini" @click="Mianbandakai(['kefu',shu.row])"></el-button>
							<el-button icon="el-icon-edit-outline" size="mini" @click="Mianbandakai(['shanghu',shu.row])"></el-button>
							<el-button icon="el-icon-close" size="mini" @click="Shanchu(shu)"></el-button>
						</template>
					</el-table-column>
				</el-table>				
				<el-pagination layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao" :current-page.sync="so.ye"
				 @current-change="CSH" style="margin-top: 30px;">
				</el-pagination>
			</el-tab-pane>
			<el-tab-pane :label="mianban_shu.id?'编辑商品':'新增商品'" name="xinzeng" :closable="mianban_shu.id>0">
				<el-form class="shanghu" :model="mianban_shu" style="overflow-y: scroll; height: 90vh;margin-bottom: 50px;">
					<el-form-item label="绑定会员" label-width="100px">
						<Huiyuan v-model="mianban_shu.nicheng" :hyid.sync="mianban_shu.hyid" :touxiang.sync="mianban_shu.touxiang"></Huiyuan>
					</el-form-item>
					<el-form-item label="Logo" label-width="100px">					
						<Shangwenjian v-model="mianban_shu.logo" anniu="选择图片" :leixing="tu"></Shangwenjian>
					</el-form-item>
					<el-form-item label="身份证(正)" label-width="100px" v-if="mianban_shu.qita">						
						<Shangwenjian v-model="mianban_shu.qita.shenfenzhen" anniu="选择图片" :leixing="tu"></Shangwenjian>
					</el-form-item>
					<el-form-item label="身份证(反)" label-width="100px" v-if="mianban_shu.qita">						
						<Shangwenjian v-model="mianban_shu.qita.shenfenfan" anniu="选择图片" :leixing="tu"></Shangwenjian>
					</el-form-item>
					<el-form-item label="营业执照" label-width="100px" v-if="mianban_shu.qita">						
						<Shangwenjian v-model="mianban_shu.qita.yingyezhao" anniu="选择图片" :leixing="tu"></Shangwenjian>
					</el-form-item>
					<el-form-item label="店铺昵称" label-width="100px">
						<el-input v-model="mianban_shu.ming"></el-input>
					</el-form-item>
					<el-form-item label="企业全称" label-width="100px">
						<el-input v-model="mianban_shu.gongsiming"></el-input>
					</el-form-item>
					<el-form-item label="客服电话" label-width="100px">
						<el-input style="width:100%" v-model="mianban_shu.dianhua" />
					</el-form-item>
					<el-form-item label="营业时间" label-width="100px" v-if="mianban_shu">
						  <el-time-select placeholder="起始时间" v-model="mianban_shu.yingyekaishishijian" :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"></el-time-select>
						  <el-time-select placeholder="结束时间" v-model="mianban_shu.yingyejieshushijian" :picker-options="{ start: '00:00', step: '00:30', end: '23:30', minTime: mianban_shu.yingyekaishishijian}"></el-time-select>
					</el-form-item>
					<el-form-item label="配送方式" label-width="100px">
						<el-radio-group v-model="mianban_shu.peisongfangshi">
						    <el-radio label="0">派送上门</el-radio>
						    <el-radio label="1">到店自提</el-radio>						   
						  </el-radio-group>
					</el-form-item>
					<el-form-item label="派送费" label-width="100px"  v-if="mianban_shu.qita">
						<el-input style="width:100%" v-model="mianban_shu.qita.paisongfei">
							<template slot="append">元</template>
						</el-input>						
					</el-form-item>
					<el-form-item label="佣金比例" label-width="100px"  v-if="mianban_shu.qita">
						<el-input style="width:100%" v-model="mianban_shu.qita.yongjin">
							<template slot="append">%</template>
						</el-input>						
					</el-form-item>
					<el-form-item label="地区" label-width="100px">
						<Dizhi v-model="mianban_shu.shengshiqu" v-if="tabs=='xinzeng'"></Dizhi>
					</el-form-item>
					<el-form-item label="详细地址" label-width="100px">
						<el-input style="width:100%" v-model="mianban_shu.dizhi" />
					</el-form-item>
					<el-form-item label="地图坐标" label-width="100px">
						<el-input style="width:40%" v-model="mianban_shu.jingdu">
							<template slot="append">经度</template>
						</el-input>
						<el-input style="width:40%" v-model="mianban_shu.weidu">
							<template slot="append">纬度</template>
						</el-input>
						<el-button @click="$refs.ditu.CSH(mianban_shu.jingdu,mianban_shu.weidu)">选择坐标</el-button>
					</el-form-item>
					<el-form-item label="简介" label-width="100px">
						<Bianjiqi v-model="mianban_shu.jianjie" v-if="tabs=='xinzeng'"></Bianjiqi>
					</el-form-item> 
					<div class="demo-drawer__footer">					
						<el-button type="primary" @click="Mianban_post('shanghu')">确 定</el-button>
					</div>
				</el-form>
			</el-tab-pane>
		</el-tabs>
		<el-drawer title="客服管理" :visible.sync="mianban.kefu" direction="rtl" size="50%" style="">
			<!-- <el-divider></el-divider> -->
			<el-table :data="mianban_shu.lie" style="">
				<el-table-column property="hyid" label="会员ID" width="120"></el-table-column>
				<el-table-column label="会员" width="250">
					<template slot-scope="shu">
						<el-avatar shape="square" :src="shu.row.touxiang" v-if="shu.row.touxiang"></el-avatar>
						<span style="position:absolute; top:1.25rem; left: 3.75rem;color: #428bca;">{{shu.row.nicheng}}</span>
					</template>
				</el-table-column>
				<el-table-column property="xingming" label="姓名" width="150"></el-table-column>
				<el-table-column property="shijian" label="时间" width="150"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="shu">
						<el-button size="small" @click="Shanchukefu(shu.row)"><i class="el-icon-close"></i></el-button>
					</template>
				</el-table-column>
			</el-table>
			<Huiyuan v-model="kefu.nicheng" :hyid.sync="kefu.hyid" :touxiang.sync="kefu.touxiang" style="width: 50%;"></Huiyuan>
			<el-button type="danger" style="margin-left: 40px; margin-top: 20px;" size="small" @click="Tianjiakefu">添加</el-button>
		</el-drawer>
		<el-drawer title="飞鹅打印机设置" :visible.sync="mianban.dayin" direction="rtl" size="30%" style="">
			<el-form class="shanghu" :model="mianban_shu" style="overflow-y: scroll; height: 90vh;margin-bottom: 50px;">			
				<el-form-item label="编号SN" label-width="80px">
					<el-input v-model="mianban_shu.dayinjibianhao"></el-input>
				</el-form-item>			
				<div class="demo-drawer__footer">					
					<el-button type="primary" @click="Mianban_post('dayin')">确 定</el-button>
				</div>
			</el-form>			
		</el-drawer>
		<Gaodeditu ref="ditu" @queren="Queren"></Gaodeditu>
	</div>
</template>

<script>
	var that;
	import Shangtu from '../../zujian/Shangtu.vue'
	import Gaodeditu from '../../zujian/Gaodeditu.vue'
	import Huiyuan from '../../zujian/Huiyuan.vue'
	import Dizhi from '../../zujian/Dizhi.vue'
	import Bianjiqi from '../../zujian/Bianjiqi.vue'
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	export default {
		data() {
			return {
				so: {
					ye: 1,
					jitiao: 20,
					leixing: 1
				},
				shu: [],
				zongshu: 0,
				mianban: {
					kefu: false,
					shanghu: false,
					dayin:false
				},
				mianban_shu: {},
				kefu: {},
				tu: "tu",
				tabs:'lie',	
			}
		},
		components: {
			Shangtu,
			Gaodeditu,
			Huiyuan,
			Dizhi,
			Bianjiqi,
			Shangwenjian
		},
		created() {
			that = this;
			that.CSH();
		},
		methods: {
			CSH() {
				this.$post('k=shanghu', that.so, function(s) {
					that.shu = s.shu.lie;
					that.zongshu = Number(s.shu.zongShu);
				});
			},
			Shenhe(e) {
				this.$post('k=shanghu&c=xiugai', {
					id: e.id,
					zhuangtai: e.zhuangtai
				}, function(s) {
					if (s.shi != 1) {
						that.$xiaoxi(s.shu);
					}
				});
			},
			Peisongfangshi(e){				
				this.$post('k=shanghu&c=xiugai', {
					id: e.id,
					peisongfangshi: e.peisongfangshi
				}, function(s) {
					if (s.shi != 1) {
						that.$xiaoxi(s.shu);
					}
				});
			},
			Shanchu(e) {
				this.$confirm('确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.shu.splice(e.$index, 1);
					this.$post('k=shanghu&c=shandian', {
						id: e.row.id
					}, function(s) {
						if (s.shi != 1) {
							that.$xiaoxi(s.shu);
						}
					});
				});
			},
			Mianbandakai(e) {
				that.mianban[e[0]] = true;
				if (e[0] == "kefu") {
					that.Kefu(e[1].id);
				}else if(e[0] == "shanghu"){
					that.tabs='xinzeng';
					if(e[1].qita.length==0){
						this.$set(e[1],'qita',{})				
					}
					that.mianban_shu = e[1];
				} else {
					that.mianban_shu = e[1] || [];
				}
			},
			Mianban_post(e) {
				if (e == 'shanghu') {
					this.$post('k=shanghu&c=Xiugai', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
						}
					});
				}else if(e=='dayin'){
					this.$post('k=shanghu&c=dayin', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
						}
					});
				}
				that.mianban[e] = false;
			},
			Queren(e) {
				this.mianban_shu.jingdu = e.jingdu;
				this.mianban_shu.weidu = e.weidu;
			},
			Kefu(shanghu) {
				this.$post('k=shanghu&c=kefu', {
					id: shanghu
				}, function(s) {
					that.mianban_shu = {
						shanghu: shanghu,
						lie: s.shu
					};
				});
			},
			Shanchukefu(e) {
				this.$post('k=shanghu&c=shanchukefu', {
					hyid: e.hyid,
					shanghu: e.shanghu
				}, function(s) {
					that.$xiaoxi(s.shu);
					that.Kefu(e.shanghu);
				});
			},
			Tianjiakefu() {
				if (!this.kefu.hyid) {
					return false;
				}
				this.$post('k=shanghu&c=tianjiakefu', {
					hyid: this.kefu.hyid,
					shanghu: this.mianban_shu.shanghu
				}, function(s) {
					if (s.shi == 1) {
						that.Kefu(that.mianban_shu.shanghu);
					} else {
						that.$xiaoxi(s.shu);
					}
				});
			},
			Tabremove(e){
				that.tabs='lie';			
				that.mianban_shu={};
			},
			Tabclick(){
				if(!that.mianban_shu.id){
					that.mianban_shu={qita:{}};
				}				
			}

		},
	}
</script>
<style scope>
	.annui {
		display: flex;
		justify-content: flex-start;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.hexiaoyuan {
		border: 1px dashed #dcdfe6;
		margin: 0 auto;
		width: 60%;
		display: flex;
		justify-content: space-between;
	}

	.shanghu {
		padding: 10px 40px;
	}

	.el-drawer__open .el-drawer.rtl {
		padding: 10px 30px;
	}
</style>
